import { render, staticRenderFns } from "./discrepancy-resolution.vue?vue&type=template&id=f6ecdf2e&"
import script from "./js/discrepancy-resolution.js?vue&type=script&lang=js&"
export * from "./js/discrepancy-resolution.js?vue&type=script&lang=js&"
import style0 from "./discrepancy-resolution.vue?vue&type=style&index=0&id=f6ecdf2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports